import { tokens } from './tokens'

const darkColors = {
  background: tokens.color.background,
  backgroundHover: tokens.color.backgroundSecondary,
  backgroundPress: tokens.color.backgroundTertiary,
  backgroundFocus: tokens.color.backgroundSecondary,
  backgroundStrong: tokens.color.backgroundSecondary,
  backgroundTransparent: 'transparent',

  color: tokens.color.textPrimary,
  colorHover: tokens.color.textPrimary,
  colorPress: tokens.color.textSecondary,
  colorFocus: tokens.color.textPrimary,
  colorTransparent: 'transparent',

  borderColor: tokens.color.border,
  borderColorHover: tokens.color.orangePrimary,
  borderColorFocus: tokens.color.orangePrimary,
  borderColorPress: tokens.color.orangeSecondary,

  placeholderColor: tokens.color.textMuted,

  shadowColor: 'rgba(0, 0, 0, 0.5)',
  shadowColorHover: 'rgba(255, 99, 0, 0.2)',

  accentBackground: tokens.color.orangePrimary,
  accentColor: tokens.color.textPrimary,
}

export const dark = {
  ...darkColors,
}

export const dark_orange = {
  ...darkColors,
  background: tokens.color.orangePrimary,
  backgroundHover: tokens.color.orangeSecondary,
  backgroundPress: '#E55A00',
  backgroundFocus: tokens.color.orangeSecondary,
  backgroundStrong: tokens.color.orangePrimary,
  color: tokens.color.textPrimary,
}

export const dark_card = {
  ...darkColors,
  background: tokens.color.cardBackground,
  backgroundHover: tokens.color.cardBackgroundHover,
  borderColor: tokens.color.border,
}

export const dark_subtle = {
  ...darkColors,
  color: tokens.color.textSecondary,
  background: 'transparent',
  backgroundHover: tokens.color.backgroundSecondary,
}

export const themes = {
  dark,
  dark_orange,
  dark_card,
  dark_subtle,
} as const

export type AppThemes = typeof themes
